import React from 'react';
import { ShieldCheck, Sparkles } from 'lucide-react';
import { soundEngine } from '../utils/soundAndSpeech';

interface RegistrationRequiredCardProps {
  title?: string;
  description?: string;
  onSignUp: () => void;
  onSignIn: () => void;
}

export const RegistrationRequiredCard: React.FC<RegistrationRequiredCardProps> = ({
  title = 'Join the Quick!Bible Community',
  description = 'Connect with Bible scholars worldwide. Share your Scripture milestones, celebrate achievements, challenge friends, and grow together in God\'s Word.',
  onSignUp,
  onSignIn,
}) => {
  return (
    <div className="w-full max-w-2xl mx-auto py-10 sm:py-12 px-4 text-center box-border">
      <div className="rounded-3xl bg-[#141414] border border-[#262626] p-8 sm:p-10 shadow-2xl space-y-6">
        <div className="w-16 h-16 rounded-2xl bg-[#F97316]/15 text-[#F97316] flex items-center justify-center mx-auto border border-[#F97316]/30 shadow-inner">
          <ShieldCheck className="w-8 h-8" />
        </div>
        <div className="space-y-2">
          <h2 className="text-2xl sm:text-3xl font-extrabold text-[#FAFAFA] tracking-tight">
            {title}
          </h2>
          <p className="text-sm text-[#A3A3A3] leading-relaxed max-w-md mx-auto">
            {description}
          </p>
        </div>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 pt-2">
          <button
            type="button"
            onClick={() => {
              soundEngine.playClick();
              onSignUp();
            }}
            className="w-full sm:w-auto px-6 py-3 rounded-xl bg-gradient-to-r from-[#FF8A00] to-[#EA580C] hover:brightness-110 text-white font-bold text-sm shadow-lg shadow-orange-950/40 transition-all cursor-pointer"
          >
            Create Free Account
          </button>
          <button
            type="button"
            onClick={() => {
              soundEngine.playClick();
              onSignIn();
            }}
            className="w-full sm:w-auto px-6 py-3 rounded-xl bg-[#1C1C1C] hover:bg-[#262626] border border-[#404040] text-[#FAFAFA] font-bold text-sm transition-all cursor-pointer"
          >
            Already have an account? Sign In
          </button>
        </div>
      </div>
    </div>
  );
};
